import initPlugins from './initPlugins';
import destroyPlugins from './destroyPlugins';

export {
  initPlugins,
  destroyPlugins,
};



// WEBPACK FOOTER //
// ./scripts/plugins/index.js